// extracted by mini-css-extract-plugin
export default {"header":"ProductDetailsSection_header__RHopJ","content":"ProductDetailsSection_content__lzdtD","contentList":"ProductDetailsSection_contentList__6jgdo"};